import { supabase } from '../lib/supabase';
import type { ExtracaoFaturaCrmResposta, ExtracaoDocumentoCrmResposta } from '../../types';

/** Envia um PDF de fatura para a Edge Function determinística exclusiva do CRM
 *  (stateless — não grava em extracoes_faturas, só extrai e devolve). */
export async function extrairFaturaCrm(file: File): Promise<ExtracaoFaturaCrmResposta> {
  const form = new FormData();
  form.append('fatura', file);
  const { data, error } = await supabase.functions.invoke('extrair-fatura-crm', { body: form });
  if (error) {
    let msg = error.message || 'Falha ao chamar a extração.';
    try {
      const body = await (error as any).context?.json?.();
      if (body?.error) msg = body.error;
    } catch { /* ignore */ }
    return { ok: false, error: msg };
  }
  return data as ExtracaoFaturaCrmResposta;
}

/** Envia um documento de identidade (PDF ou foto) para leitura de melhor esforço
 *  (RG/CNH/Cartão CNPJ/Contrato Social) — nome/CPF-CNPJ/tipo, todos opcionais. */
export async function extrairDocumentoCrm(file: File, tipoCliente?: 'PF' | 'PJ'): Promise<ExtracaoDocumentoCrmResposta> {
  const form = new FormData();
  form.append('documento', file);
  if (tipoCliente) form.append('tipo_cliente', tipoCliente);
  const { data, error } = await supabase.functions.invoke('extrair-documento-crm', { body: form });
  if (error) {
    let msg = error.message || 'Falha ao chamar a extração do documento.';
    try {
      const body = await (error as any).context?.json?.();
      if (body?.error) msg = body.error;
    } catch { /* ignore */ }
    return { ok: false, error: msg };
  }
  return data as ExtracaoDocumentoCrmResposta;
}
